export default __webpack_public_path__ + "static/media/sc.94eb91dd.svg";